import type Transition from '@ember/routing/transition';
import type { DS } from 'ember-data';
import { hash } from 'rsvp';
import { type Registry as Services, service } from '@ember/service';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type ActionBookingsMessagesController from 'uplisting-frontend/pods/action/bookings/messages/controller';
import type CalendarBookingsMessagesController from 'uplisting-frontend/pods/xcalendar/bookings/messages/controller';

interface IParams {
  replyId?: string;
}

interface IModel {
  booking: ModelRegistry['booking'];
  reply?: Promise<ModelRegistry['contextual-reply']>;
  messagingChannels: Promise<
    DS.PromiseArray<ModelRegistry['messaging-channel']>
  >;
}

export default abstract class SidebarBookingsMessagesRoute extends BaseRoute {
  @service('repositories/contextual-reply')
  contextualReplyRepository!: Services['repositories/contextual-reply'];

  @service('repositories/messaging-channel')
  messagingChannelRepository!: Services['repositories/messaging-channel'];

  abstract parentRoute: string;

  model(params: IParams) {
    const booking = this.modelFor(this.parentRoute) as ModelRegistry['booking'];
    const data: IModel = {
      booking,
      messagingChannels: this.messagingChannelRepository.query({
        booking_id: booking.id,
      }),
    };

    if (params.replyId) {
      data.reply = this.contextualReplyRepository.find(
        params.replyId,
        data.booking,
      );
    }

    return hash(data);
  }

  setupController(
    controller: ActionBookingsMessagesController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, model);
  }

  resetController(
    controller:
      | ActionBookingsMessagesController
      | CalendarBookingsMessagesController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    controller.reply = undefined;
    controller.replyId = undefined;

    this.contextualReplyRepository.unloadAll();
  }
}
